module.exports = __webpack_public_path__ + "img/shuttle.5cd98d91.svg";